var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.editable && !_vm.disabled,
            expression: "editable&&!disabled",
          },
        ],
        staticClass: "col-12",
      },
      [
        _c(
          "q-btn-group",
          { staticClass: "float-right", attrs: { outline: "" } },
          [
            _c("c-btn", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.process.estimationFlag !== "Y" && !_vm.btnEditable,
                  expression: "process.estimationFlag!=='Y'&&!btnEditable",
                },
              ],
              attrs: {
                isSubmit: _vm.isEstimationComplete,
                url: _vm.estimationCompleteUrl,
                param: _vm.saveProcess,
                mappingType: "PUT",
                label: _vm.$comm.getLangLabel("LBL0001191", {
                  s1: _vm.process.processName,
                }),
                icon: "check",
              },
              on: {
                beforeAction: _vm.estimationCompleteProcess,
                btnCallback: _vm.estimationCompleteProcessCallback,
              },
            }),
            _c("c-btn", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.process.estimationFlag === "Y" && !_vm.btnEditable,
                  expression: "process.estimationFlag==='Y'&&!btnEditable",
                },
              ],
              attrs: {
                isSubmit: _vm.isComplete,
                url: _vm.completeUrl,
                param: _vm.saveProcess,
                mappingType: "PUT",
                label: "LBL0001162",
                icon: "check",
              },
              on: {
                beforeAction: _vm.completeProcess,
                btnCallback: _vm.completeProcessCallback,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("c-tab", {
          attrs: {
            type: "tabcard",
            align: "left",
            tabItems: _vm.tabItems,
            height: _vm.tabHeight,
            inlineLabel: true,
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function (tab) {
                return [
                  _c(tab.component, {
                    key: tab.componentKey,
                    tag: "component",
                    attrs: {
                      process: _vm.process,
                      param: _vm.param,
                      height: _vm.height,
                      btnEditable: _vm.btnEditable,
                      updateBtnData: _vm.updateBtnData,
                      estimationUpdateBtnData: _vm.estimationUpdateBtnData,
                    },
                    on: {
                      "update:process": function ($event) {
                        _vm.process = $event
                      },
                      research: _vm.research,
                    },
                  }),
                ]
              },
            },
          ]),
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }